import _ from 'lodash';
import { useForm } from 'react-final-form';
import { LabelFormComponent } from '@/formbuilder/LabelFormComponent.atom';
import { PasswordCheckFormComponent } from '@/formbuilder/PasswordCheckFormComponent.atom';
import { TextFieldFormComponent } from '@/formbuilder/TextFieldFormComponent.atom';
import { getPasswordErrorText, validPassword } from '@/utilities/password.utilities';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface PasswordGroupIF extends ValidatingFormComponent<string | number> {
  component: 'PasswordGroupFormComponent';
  name: string;
  includeIf?: boolean;
}

// PasswordGroupFormComponent reads password values directly from the React Final Form state via useForm().
export const PasswordGroupFormComponent = ({ testId = 'passwordGroup' }: PasswordGroupIF) => {
  const validatePassword = (value: string | number | undefined) => !validPassword((value ?? '').toString());
  const formState = useForm().getState();
  const formValues = formState.values;
  const newPasswordErrorText = getPasswordErrorText((formValues?.newPassword ?? '').toString());

  return (
    <div className="flexRowContainer" data-testid={testId}>
      <div className="mb8">
        <TextFieldFormComponent
          component="TextFieldFormComponent"
          name="newPassword"
          label="USER.PASSWORD"
          value=""
          onChange={_.noop}
          placeholder="USER.PASSWORD_PROMPT"
          validation={validatePassword}
          customErrorText={newPasswordErrorText}
          size="sm"
          type="password"
          testId="newPassword"
        />
        <LabelFormComponent
          component="LabelFormComponent"
          name="confirmPasswordLabel"
          value="USER.PASSWORD_CHECK"
          extraClassNames="mt8 text-bolder"
        />
        <PasswordCheckFormComponent
          component="PasswordCheckFormComponent"
          name="confirmPassword"
          value=""
          onChange={_.noop}
          placeholder="USER.PASSWORD_CHECK_PROMPT"
          validation={validatePassword}
          extraClassNames="mb10 width-maximum"
          size="sm"
          type="password"
          testId="confirmPassword"
        />
      </div>
    </div>
  );
};
